import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMessageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path
      fill="#fff"
      d="M1.75 3.063v7a.875.875 0 0 0 .875.874h8.75a.875.875 0 0 0 .875-.874v-7H1.75Zm0-.876h10.5a.875.875 0 0 1 .875.876v7a1.75 1.75 0 0 1-1.75 1.75h-8.75a1.75 1.75 0 0 1-1.75-1.75v-7a.875.875 0 0 1 .875-.876Z"
    />
    <path
      fill="#fff"
      d="M12.36 3.063 8.975 6.93a2.625 2.625 0 0 1-3.952 0L1.641 3.063h10.718Zm-9.556 0 2.878 3.29a1.75 1.75 0 0 0 2.635 0l2.88-3.29H2.803Z"
    />
  </svg>
);
export default SvgMessageIcon;
